import { MeurhArquivosEmpresaService } from '../../empresa/arquivos.empresa.service';
import { MeurhArquivosTrabalhadorService } from '../../trabalhador/arquivos.trabalhador.service';

export class MeurhVisualizarArquivoModalService {
	static $inject = ['$uibModal'];

	constructor(private $uibModal: ng.ui.bootstrap.IModalService) {
	}

	open(
        entity: string,
        fileType: string,
        service: MeurhArquivosTrabalhadorService | MeurhArquivosEmpresaService
    ) {
		return this.$uibModal.open({
			template: require('html-loader!./visualizararquivo.modal.html'),
			controller: 'MeurhVisualizarArquivoModalController',
			controllerAs: 'mrh_vslzr_rqv_mdl_cntrllr',
			windowClass: 'nsj-modal-lg-no-height',
			backdrop: 'static',
			resolve: {
				entity: (): string => entity,
                fileType: (): string => fileType,
                service: (): MeurhArquivosTrabalhadorService | MeurhArquivosEmpresaService => service
			}
		});
	}
}
